import { render } from "./CreateQuotePage.vue?vue&type=template&id=27081d5a"
import script from "./CreateQuotePage.vue?vue&type=script&lang=js"
export * from "./CreateQuotePage.vue?vue&type=script&lang=js"

import "@/css/CreateQuotePage.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__